import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';

import metadata from './MLQuotesAdditionalFilter.metadata.json5';
import messages from './MLQuotesAdditionalFilter.messages';
import styles from './MLQuotesAdditionalFilter.module.scss';

const MLQuotesAdditionalFilter = (props) => {
    const {
        filterData,
        updateFilterData,
        isBookRollDisplay,
        isPCSorIA
    } = props;
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();

    const initiatorsAvailVal = [translator(messages.consumer), translator(messages.agent), translator(messages.compRater)].map((initiator) => {
        return {
            code: initiator,
            name: initiator
        }
    });

    const onValueChange = (value, path) => {
        _.set(filterData, path, value);
        updateFilterData(filterData);
        refreshData();
    }

    const overrideProps = {
        initiators: {
            availableValues: initiatorsAvailVal
        },
        isBookRoll: {
            visible: (isPCSorIA) && isBookRollDisplay
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={filterData}
            onValueChange={onValueChange}
            classNameMap={styles}
        />
    );
};

MLQuotesAdditionalFilter.propTypes = {
    filterData: PropTypes.shape({}).isRequired,
    updateFilterData: PropTypes.func.isRequired,
    assignedByValues: PropTypes.array.isRequired,
    prioritiesTypelist: PropTypes.array.isRequired,
    isPCSorIA: PropTypes.bool.isRequired,
    isBookRollDisplay: PropTypes.bool.isRequired
};

export default MLQuotesAdditionalFilter;
